import { createSlice } from "@reduxjs/toolkit";
import {
  getCategoryWithFilter,
  updateCategoryStatus,
  deleteCategory,
  bulkDeleteCategory,
  getCategoryWithId,
  getCategoryWithPage,
} from "./thunk";

const initialState = {
  categories: {
    data: {
      data: [],
      totalCount: 0,
      currentPage: 1
    }
  },
  singleCategory: null,
  categoryInfo: null,
  loading: false,
  error: null,
  filterParams: {
    currentPage: 1,
    perPage: 20,
  },
};

const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    setFilterParams: (state, action) => {
      state.filterParams = {
        ...state.filterParams,
        ...action.payload,
      };
    },
    clearSingleCategory: (state) => {
      state.singleCategory = null;
    },
    clearCategoryInfo: (state) => {
      state.categoryInfo = null;
    },
  },
  extraReducers: (builder) => {
    builder

      // 🔄 FETCH WITH FILTER
      .addCase(getCategoryWithFilter.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCategoryWithFilter.fulfilled, (state, action) => {
        console.log(action.payload);
        state.loading = false;
        state.categories = {
          data: action.payload?.data || [],
          count: action.payload?.count || 0,
        };
        
        state.error = null;
      })
      .addCase(getCategoryWithFilter.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch categories";
        state.categories = { data: [], count: 0 };
      })

      // 📄 FETCH WITH PAGINATION
      .addCase(getCategoryWithPage.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCategoryWithPage.fulfilled, (state, action) => {
        state.loading = false;
        state.categories.data = {
          data: action.payload?.data || [],
          totalCount: action.payload?.totalCount || 0,
          currentPage: action.payload?.currentPage || 1
        };
        state.error = null;
      })
      .addCase(getCategoryWithPage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch categories with pagination";
        state.categories.data = {
          data: [],
          totalCount: 0,
          currentPage: 1
        };
      })

      // 🔍 FETCH SINGLE CATEGORY
      .addCase(getCategoryWithId.pending, (state) => {
        state.loading = true;
        state.singleCategory = null;
      })
      .addCase(getCategoryWithId.fulfilled, (state, action) => {
        state.loading = false;
        state.singleCategory = action.payload;
        state.error = null;
      })
      .addCase(getCategoryWithId.rejected, (state, action) => {
        state.loading = false;
        state.singleCategory = null;
        state.error = action.error.message || "Failed to fetch category by ID";
      })

      // ✏️ UPDATE CATEGORY STATUS
      .addCase(updateCategoryStatus.fulfilled, (state, action) => {
        const updated = action.payload;
        if (Array.isArray(state.categories?.data)) {
          const index = state.categories.data.findIndex(
            (category) => category.id === updated.id
          );
          if (index !== -1) {
            state.categories.data[index] = updated;
          }
        }
      })
      
      // ❌ DELETE CATEGORY
      .addCase(deleteCategory.fulfilled, (state, action) => {
        const deletedId = action.payload;
        if (Array.isArray(state.categories?.data)) {
          state.categories.data = state.categories.data.filter(
            (category) => category.id !== deletedId
          );
          state.categories.count -= 1;
        }
      })
      

      // 🗑 BULK DELETE CATEGORIES
      .addCase(bulkDeleteCategory.fulfilled, (state, action) => {
        const deletedIds = action.payload;
        state.categories.data = state.categories.data.filter(
          (category) => !deletedIds.includes(category.id)
        );
      });
  },
});

export const {
  setFilterParams,
  clearSingleCategory,
  clearCategoryInfo,
} = categorySlice.actions;
export default categorySlice.reducer;
